import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface TrustBadgeProps {
  type: 'WIC' | 'EBT';
  size?: 'xs' | 'sm' | 'md' | 'lg';
}
export function TrustBadge({
  type,
  size = 'md'
}: TrustBadgeProps) {
  const sizeClasses = {
    xs: 'text-[9px] px-1.5 py-0.5',
    sm: 'text-[10px] px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
    lg: 'text-sm px-3 py-1.5'
  };
  const iconSizes = {
    xs: 'w-2.5 h-2.5',
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4'
  };
  const colors = {
    WIC: 'bg-[#1e3a8a] text-white',
    EBT: 'bg-[#ff6b35] text-white'
  };
  return <div className={`inline-flex items-center gap-1 rounded-full font-bold ${colors[type]} ${sizeClasses[size]}`} data-id="element-266">
      <CheckCircle2 className={iconSizes[size]} data-id="element-267" />
      <span data-id="element-268">{type}</span>
    </div>;
}